<template>
  <div id="jobPreferences">
    <div class="jobPreferencesTitle">
      求职偏好类型对比
    </div>

    <div class="chartInstanceBox">
      <div id="chartInstance" ref="chartInstance"></div>
    </div>
  </div>
</template>

<script>
import { getMemberPreferencesApi } from '@/utils/api'

export default {
  data() {
    return {
      sandianData: [],
    }
  },
  mounted() {
    this.getMemberPreferences()
  },
  methods: {
    async getMemberPreferences(data) {
      await getMemberPreferencesApi({
        ...data
      }).then(res => {
        this.sandianData = res.data.data
        this.chartInstanceInit()
      })
    },

    chartInstanceInit() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        xAxis: {
          type: "value",
          // name: "参数/单位", // x轴的名字，可以理解成单位
          splitLine: {
            //去除网格线
            show: false,
          },
          splitArea: { show: false }, //去除网格区域，否则会有一片区域
          axisLabel: {
            show: false,
            // 设置x轴的文字的样式
            textStyle: {
              show: false,
              color: "#343434",
              fontSize: "12",
            },
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true, // 把x轴从实线变成虚线
            lineStyle: {
              // 设置x轴线条样式的颜色
              color: "#fff",
              width: 1,
              type: "solid",
            },
          },
          scale: true, // 设置数据自动缩放，要不然数据多的话就堆一块了
        },
        yAxis: {
          type: "value",
          nameTextStyle: {
            // color: "#BFBFBF",
            nameLocation: "end",
          },
          axisTick: {
            show: false, // 去掉y轴的凸出刻度
          },
          axisLine: {
            show: false, // 把y轴从实线变成虚线
          },
          splitLine: {
            //去除网格线
            show: true,
            lineStyle: {
              color:'#343434',
              type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
            },
          },
          splitArea: { show: false }, //去除网格区域
          axisLabel: {
            show: false,

            // 设置y轴的文字的样式
            textStyle: {
              show: false,
              // color: "#BDBDBD",
              fontSize: "12",
            },
          },
          scale: true, // 设置数据自动缩放，要不然数据就堆一块了
          // show: false,
        },
        grid: {
          // 位置
          show: true,
          x: 19,
          y: 50,
          x2: 19,
          y2: 19,
          borderWidth: 0, // 去除图表的边框
        },
        tooltip: {
          formatter: function (obj) {
            let value = obj.value;
            return (
              '<div style=" font-size: 18px;">' +
              obj.seriesName + ':' + value[1] + '个' +
              "</div>"
            );
          },
        },
        series: [],
        color: ["#4CD3D4", "#60BD65", "#46A7EA", "#E99E44", "#DC403F"], // 控制圆环图的颜色
      };
      let legendData = []
      // console.log( this.sandianData);
      this.sandianData.map(item => {
        initOption.series.push({
          data: [[item.num, item.value]],
          name: item.name,
          type: "scatter", // 类型为散点图
          itemStyle: {
            // 设置散点图的透明度
            opacity: 0.85,
          },
          symbolSize: function (data) {
            return Math.sqrt(data[1] * 100);
          },
        })
        legendData.push(item.name)
        initOption.legend = {
          top: 10,
          right: 19,
          type:'scroll',
          data: legendData,
          textStyle: {
            fontSize: 12,
            color: '#FFFFFF'
          }
        }
      })
      chartInstance.setOption(initOption, true)
    }
  }
};
</script>

<style lang="scss" scoped>
#jobPreferences {
  padding-left: 41px;
  margin-bottom: 50px;
}

.chartInstanceBox {
  position: relative;
  width: 416px;
  height: 261px;
}

#chartInstance {
  width: 416px;
  height: 261px;

}

.left2Bg {
  width: 162px;
  height: 162px;
  background-image: url('../assets/left2Bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .proportion {
    font-size: 31px;
    /* color: linear-gradient(0deg, #291AEB 0%, #258FFF 50.244140625%, #E8FFFF 100%); */
    margin-bottom: 17px;
    background: linear-gradient(to right, #E8FFFF, #258FFF, #291AEB);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .proportionText {
    font-size: 19px;
    color: #FFFFFF;
  }
}

.jobPreferencesTitle {
  font-weight: bold;
  font-size: 28px;
  color: #0EE1F4;
  background: linear-gradient(179deg, #0EE1F4 0%, #0096FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
}
</style>